import { useNavigate } from "react-router-dom";
import HexPageTitle from "../../../../components/HexPageTitle";
import { getLabel } from "../../../../hooks/use-labels";
import FilterSearchBox from "../../../Home/Components/FilterSearchBox";
import BackButton from "../../../../components/BackButton";
import ProductFilters from "../ProductFilters";

const SupplierProductViewHeader = ({
  link,
  filters,
  pageTitle,
  updateFilter,
  accessoryProps,
}) => {
  const navigate = useNavigate();

  const onBack = () => {
    navigate(link.path, {
      ...(link.previousState && { state: link.previousState }),
    });
  };

  return (
    <div
      className={`content-container ${link && "material-product-container"}`}
    >
      {link && <BackButton onClick={onBack} text={getLabel("backLabel")} />}

      <div
        className={`${
          link && "material-product-header"
        } flex align-center justify-between`}
      >
        <HexPageTitle title={pageTitle} />

        <FilterSearchBox
          filterValues={filters}
          onSaveFilter={updateFilter}
          FilterComponent={(props) => (
            <ProductFilters
              {...props}
              accessoryProps={accessoryProps || null}
            />
          )}
          dropdownPlacement="bottomRight"
        />
      </div>
    </div>
  );
};

export default SupplierProductViewHeader;
